import DataModelView from '../view/DataModelView';

export default class PropertyPageView extends DataModelView {
}